import { useReduxState } from 'hooks';
import { getNumberOfMatchingCompetencies } from 'lib/competencies';
import { TitleWithIcon } from 'components/common';
import { Modal, ModalContent, ModalPortal } from 'components/common/modal';
import { ProfileCompetenciesCompareResult } from '.';

import type { GetCompetencyProfilesRes } from 'shared-types/responses';
import type { MergedCompetency } from 'lib/competencies/getMergedCompetencies';

interface Props {
  competencyProfile?: Pick<
    GetCompetencyProfilesRes['competencyProfiles'][0],
    | 'competencies'
    | 'description'
    | 'descriptionLocales'
    | 'id'
    | 'title'
    | 'titleLocales'
  >;
  includeCompetencyProfileLink: boolean;
  onHide: () => void;
  userCompetencies: MergedCompetency[];
}

const ProfileCompetencyProfileDetails = ({
  competencyProfile,
  includeCompetencyProfileLink,
  onHide,
  userCompetencies
}: Props) => {
  const { language, messages } = useReduxState();

  const description =
    competencyProfile?.descriptionLocales?.[language] ||
    competencyProfile?.description;

  return (
    <ModalPortal>
      <Modal
        closeButton={true}
        onHide={onHide}
        title={messages.competencyProfile}
        visible={Boolean(competencyProfile)}
        width="medium"
      >
        <ModalContent>
          {competencyProfile ? (
            <>
              <TitleWithIcon
                icon="address-card"
                style={{
                  marginBottom: 10,
                  ...(description ? {} : { alignItems: 'center' })
                }}
                title={
                  competencyProfile.titleLocales?.[language] ||
                  competencyProfile.title
                }
                {...(includeCompetencyProfileLink
                  ? {
                      titleLink: {
                        as: `/competencies/profiles/${competencyProfile.id}`,
                        href: '/competencies/profiles/[profileId]'
                      }
                    }
                  : {})}
              >
                {description}
              </TitleWithIcon>

              <ProfileCompetenciesCompareResult
                numberOfMatchedCompetencies={getNumberOfMatchingCompetencies({
                  competencies: competencyProfile.competencies,
                  userCompetencies
                })}
                numberOfTotalCompetencies={
                  competencyProfile.competencies?.length || 0
                }
                profileCompetencies={competencyProfile.competencies}
                userCompetencies={userCompetencies}
              />
            </>
          ) : null}
        </ModalContent>
      </Modal>
    </ModalPortal>
  );
};

export default ProfileCompetencyProfileDetails;
